<template>
  <v-card outlined>
    <v-container style="background-color: rgb(13, 85, 242)">
      <v-row>
        <v-col cols="auto" class="pa-0" align-self="center">
          <v-card-title
            primary-title
            style="text-align: left"
            class="pa-6"
            color="white"
          >
            <span
              style="
                font-family: Inter;
                color: white;
                font-size: 18px;
                line-height: 18px;
              "
            >
              <v-icon small color="white" style="margin-top: -3px"
                >mdi-cog</v-icon
              >
              {{ groupName }} Settings
            </span>
          </v-card-title>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pa-0" style="overflow-x: auto">
      <v-container>
        <v-row class="pa-3" align-content-center>
          <div
            class="py-1 pl-3"
            style="min-width: 150px; position: inline-block"
            align-self="center"
          >
            <span
              style="
                font-family: Inter;
                font-size: 0.875rem;
                line-height: 0.875rem;
                font-weight: 600;
              "
              >Key</span
            >
          </div>
          <div
            class="py-1 px-2"
            style="position: inline-block; min-width: 180px"
            align-self="center"
          >
            <span
              style="
                font-family: Inter;
                font-size: 0.875rem;
                line-height: 0.875rem;
                font-weight: 600;
              "
              >Value</span
            >
          </div>
        </v-row>
        <v-row
          v-for="setting in settings"
          :key="setting.key"
          style="border-top: 0.6px solid rgba(0, 0, 0, 0.12)"
          class="pa-3 flex-nowrap"
          align-content-center
        >
          <div
            class="py-1 pl-3"
            style="
              min-width: 150px;
              position: inline-block;
              align-self: center;
              vertical-align: middle;
            "
          >
            <span
              style="
                font-family: Inter;
                font-size: 0.875rem;
                line-height: 0.875rem;
                font-weight: 600;
              "
            >
              {{ setting.key }}
            </span>
            <v-tooltip top>
              <template #activator="{ on, attrs }">
                <v-icon
                  class="grey-lighten-2"
                  v-bind="attrs"
                  small
                  style="margin-top: -2px; margin-left: 4px"
                  v-on="on"
                >
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span>{{ setting.description }}</span>
            </v-tooltip>
          </div>
          <div
            class="py-1 px-2"
            style="
              min-width: 180px;
              position: inline-block;
              align-self: center;
              vertical-align: middle;
            "
          >
            <span
              style="
                font-family: Inter;
                font-size: 0.875rem;
                line-height: 0.875rem;
              "
            >
              {{ displayValue(setting) }}
            </span>
          </div>
          <v-spacer></v-spacer>
          <div
            class="py-1 px-3"
            style="
              font-family: Inter;
              font-size: 12px;
              line-height: 12px;
              font-weight: 400;
              vertical-align: middle;
              text-align: right;
              width: 180px;
              position: inline-block;
              align-self: center;
            "
          >
            <v-tooltip top>
              <template #activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="editSetting(setting)"
                >
                  <v-icon color="black">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Edit setting</span>
            </v-tooltip>
          </div>
        </v-row>
      </v-container>
    </v-container>

    <!-- Add Setting Dialog -->
    <v-dialog v-model="addSettingDialog" max-width="500px">
      <v-card>
        <v-card-title>Add New Setting</v-card-title>
        <v-card-text>
          <v-text-field v-model="newKey" label="Key"></v-text-field>
          <v-text-field v-model="newValue" label="Value"></v-text-field>
          <v-text-field v-model="newGroup" label="Group"></v-text-field>
          <v-text-field
            v-model="newDescription"
            label="Description"
          ></v-text-field>
          <v-select
            v-model="newType"
            :items="typeOptions"
            label="Type"
          ></v-select>
          <v-text-field
            v-if="newType === 'ARRAY'"
            v-model="newArrayValue"
            label="Array values (comma-separated)"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="addSettingDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="createSetting">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Setting Modal -->
    <SettingEdit
      v-if="editSettingDialog"
      :setting="currentEditSetting"
      @close="editSettingDialog = false"
      @save="saveSetting"
    />
  </v-card>
</template>

<script>
import settingsService from '@/services/settingsService';
import SettingEdit from './SettingEdit.vue';

export default {
  name: 'SettingsManager',
  components: {
    SettingEdit,
  },
  props: {
    groupName: {
      type: String,
      required: true,
    },
    groupSettings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      settings: this.groupSettings,
      newKey: '',
      newValue: '',
      newGroup: '',
      newDescription: '',
      newType: 'STRING',
      newArrayValue: '',
      addSettingDialog: false,
      typeOptions: ['STRING', 'INTEGER', 'FLOAT', 'BOOLEAN', 'JSON', 'ARRAY'],
      editSettingDialog: false,
      currentEditSetting: null,
    };
  },
  watch: {
    groupSettings: {
      immediate: true,
      handler(newSettings) {
        this.settings = newSettings;
      },
    },
  },
  methods: {
    async createSetting() {
      try {
        const settingData = {
          key: this.newKey,
          value: this.newValue,
          group: this.groupName,
          description: this.newDescription,
          field_type: this.newType,
        };

        if (this.newType === 'ARRAY') {
          settingData.array_value = this.newArrayValue
            .split(',')
            .map((item) => item.trim());
        }

        await settingsService.updateSetting(this.newKey, settingData);
        this.resetNewSettingForm();
        this.$emit('setting-updated');
      } catch (error) {
        console.error('Error creating setting:', error);
      }
    },
    async updateSetting(key, value, isArray = false) {
      try {
        const updateData = isArray
          ? { array_value: value.split(',').map((item) => item.trim()) }
          : { value };
        await settingsService.updateSetting(key, updateData);
        this.$emit('setting-updated');
      } catch (error) {
        console.error('Error updating setting:', error);
      }
    },
    async deleteSetting(key) {
      try {
        await settingsService.deleteSetting(key);
        this.$emit('setting-updated');
      } catch (error) {
        console.error('Error deleting setting:', error);
      }
    },
    openAddSettingDialog() {
      this.addSettingDialog = true;
    },

    editSetting(setting) {
      this.currentEditSetting = { ...setting };
      this.editSettingDialog = true;
    },
    async saveSetting(updatedSetting) {
      try {
        await this.updateSetting(
          updatedSetting.key,
          updatedSetting.value,
          updatedSetting.type === 'ARRAY'
        );
        this.editSettingDialog = false;
        // Update the local settings array
        const index = this.settings.findIndex(
          (s) => s.key === updatedSetting.key
        );
        if (index !== -1) {
          this.settings.splice(index, 1, updatedSetting);
        }
        // Emit the event to refresh data
        this.$emit('setting-updated');
      } catch (error) {
        console.error('Error saving setting:', error);
      }
    },
    displayValue(setting) {
      if (setting.type === 'ARRAY') {
        return setting.array_value ? setting.array_value.join(', ') : '';
      }
      return setting.value;
    },
    resetNewSettingForm() {
      this.newKey = '';
      this.newValue = '';
      this.newDescription = '';
      this.newType = 'STRING';
      this.newArrayValue = '';
    },
  },
};
</script>
